import {
  onMounted,
  onUnmounted,
  reactive,
  toRefs,
} from '@vue/composition-api';

export const useScrollY = ({ offsetPercentage  }: {offsetPercentage: number}) => {
  const position = reactive({
    initY: 0,
    y: 0,
    direction: 'up',
    percentage: 0,
  });

  const getOffsetY = () => {
    const { pageYOffset } = window;
    const documentScrollTop = document.documentElement.scrollTop;
    const bodyScrollTop = document.body.scrollTop;
    return pageYOffset || documentScrollTop  || bodyScrollTop;
  };

  const handleScroll = () => {
    const curY = getOffsetY();
    if (curY > position.y) {
      position.direction = 'down';
    } else {
      position.direction = 'up';
    }
    position.y = curY;
    position.percentage = Math.min(Math.abs(position.y - position.initY) / (offsetPercentage || 100), 1);
  };

  onMounted(() => {
    console.log('onMount');
    position.y = getOffsetY();
    console.log('===init scroll y', position);
    document.addEventListener('scroll', handleScroll, true);
  });

  onUnmounted(() => {
    document.removeEventListener('scroll', handleScroll);
  });

  return toRefs(position);
};
